
import { GETSUPPLIERS, GETMYSUPPLIERS, GETMYRECIVEDSUPPLIER } from "../ActionTypes/SupplierVTypes"

const initialState ={

    suppliers : [],
    mySuppliers : [],
    myRecivedSupplier : []

}

const SupplierVReducer=(state=initialState,action)=>{

switch (action.type) {
        case GETSUPPLIERS : return {...state, suppliers: action.payload}
        case GETMYSUPPLIERS : return {...state, mySuppliers: action.payload}
        case GETMYRECIVEDSUPPLIER : return {...state, myRecivedSupplier: action.payload}
       default: return state
}
}

export default SupplierVReducer